import { createElement } from "react";

import { IPlantDTO } from "../../interfaces/IPlantDTO";
import { FiEdit } from "react-icons/fi";

interface IPlantListMobileProps {
  plants: IPlantDTO[];
  searchVal: string;
  handleEdit: (plant: IPlantDTO) => void;
}

export function PlantListMobile({
    plants,
    searchVal,  
    handleEdit, 
}: IPlantListMobileProps
): JSX.Element {

  return (
    <div
        style={{
        maxHeight: "80vh", // or any height you want
        overflowY: "auto"
        }}
    >    
        {plants
        .filter(plant => {
        if (searchVal.trim() === "") return true;
        // Split searchVal by whitespace, trim, and filter out empty strings
        const searchWords = searchVal
            .split(/\s+/) // split by any whitespace (space, tab, etc.)
            .map(word => word.trim().toLowerCase())
            .filter(Boolean);
        // Check if ANY word matches ANY field

        return searchWords.every(word =>
            `${plant.name} ${plant.location}`.toLowerCase().includes(word)
        );
        })
        .map((plant) => (
            
        <div key={plant.id}>
            <div className="tw-border tw-rounded-lg tw-p-4 tw-mb-4 tw-text-xs tw-shadow-md tw-leading-5">
                <p><strong>Name:</strong> {`${plant.name}`}</p>
                <p><strong>Location:</strong> {plant.location}</p>
                <p><strong>Admin Fee %:</strong> {typeof plant.admin_fee === 'number' ? `${(plant.admin_fee * 100).toFixed(2)}%` : plant.admin_fee}</p>
                <div className="tw-flex tw-gap-4 tw-mt-2 tw-justify-start">
                    <button className="tw-flex tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-w-20 tw-text-xs tw-bg-gray-200" onClick={() => handleEdit(plant)}>
                    {createElement(FiEdit as React.ComponentType<{ size?: number }>, { size: 16 })} <span className="tw-ml-1">Edit</span>
                    </button>
                </div>
            </div>
        </div>
        ))}
    </div>
  );
}